import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import vivaImage from 'images/brands/etn/vivaImage.png';
import vivaLogo from 'images/brands/etn/vivaLogo.svg';
import vivaDiscountTickets from 'images/brands/etn/vivaDiscountTickets.webp';
import vivaText from 'images/brands/etn/text.svg';

/**
 * LogoComponent component.
 * Render the Viva logo image.
 */
const LogoComponent = () => (
  <img src={vivaLogo} alt="Viva logo" className="h-5 inline-flex align-middle" />
);

/**
 * VivaPromoBanner component.
 * Render a promotional banner for Viva airline with discount information.
 * @param {object} props - Component props.
 * @param {boolean} props.isViajaAhorrando - Whether to show the banner. Defaults to true.
 * @param {number|null} props.discountPercent - Discount percentage. Defaults to 50 for banner display.
 */
const VivaPromoBanner = ({ isViajaAhorrando = true, discountPercent = 50 }) => {
  const { t } = useTranslation('general');

  if (!isViajaAhorrando) {
    return null;
  }

  // Format discount percentage for display
  const discountDisplay = discountPercent !== null ? `${discountPercent}%` : '50%';

  return (
    <div className="w-full mb-4 grid grid-cols-[2fr_1fr] md:grid-cols-2 items-center bg-white rounded-2xl overflow-hidden min-h-24 shadow-md">
      <div className="p-2 md:p-4">
        <span className="text-xs text-gray-medium leading-none block md:text-sm">
          {t('viva_promo_banner_message')} <LogoComponent />,{' '}
          <Trans
            t={t}
            i18nKey="viva_promo_banner_message_continuation"
            components={{
              discount: <b className="text-[#ff4b21]" />,
            }}
            values={{ discount: discountDisplay }}
          />
        </span>
      </div>
      <div className="bg-[#08a33f] rounded-tl-full flex items-center justify-center lg:justify-end h-full flex-1 px-2 gap-2">
        <span className="relative self-end">
          <img
            src={vivaDiscountTickets}
            alt="Tickets con descuento"
            className="hidden lg:block absolute inset-y-0  right-1/4
              h-14 animate-[wiggleTicket_1.2s_ease-in-out]"
          />
          <img src={vivaImage} alt="Viva avión" className="hidden lg:block h-20 self-end" />
        </span>
        <img src={vivaText} alt="Viva" className="hidden lg:block h-5" />
        <img
          src={vivaDiscountTickets}
          alt="Tickets con descuento"
          className="inline-block lg:hidden h-10"
        />
      </div>
    </div>
  );
};

VivaPromoBanner.propTypes = {
  isViajaAhorrando: PropTypes.bool,
  discountPercent: PropTypes.number,
};

export default VivaPromoBanner;
